<template>
    <svg
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
    ><path d="M34.3,21.7H29l1-6-.92-1.15-3.33-.16-1,.68a3,3,0,0,0-.07.32C24,19.68,22,21.11,21,21.57v-.33l-1-1h-4.7v2H19V32.35H15.28V34.3H20l1-1v-.45l3,1.18.36.07h8.3l1-.83,1.68-10.45ZM31.79,32.15H24.51L21,30.76V23.63c1.09-.29,4.43-1.63,5.55-7.23l1.36.07-1,6.05,1,1.14h5.33Z" /></svg>
</template>
